// extracted by mini-css-extract-plugin
export var infoItem = "_oe-2";
export var title = "_oe-0";
export var value = "_oe-1";